/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faShieldHalved} from '@fortawesome/pro-duotone-svg-icons';

const PrivacyIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faShieldHalved} {...props} />
);

export default PrivacyIcon;
